<template>
    <div class="download-app" :class="{'only-landlord': $route.name === 'landlordLogin'}">
        <div class="qrcode-wrap">
            <div class="qrcode" :class="{'mr-0': $route.name === 'landlordLogin'}">
                <div class="title">
                    個人房東APP
                </div>
                <vue-qrious :value="hostUrlLandlord"  :size="size" level="L"/>
                <div class="name" style="color:#fb9479">
                    飛豬管家
                </div>
            </div>
            <div class="qrcode" v-if="$route.name !== 'landlordLogin'">
                <div class="title">
                    房客APP
                </div>
                <vue-qrious :value="hostUrlTenant"  :size="size" level="L"/>
                <div class="name" style="color:#2479fa">
                    飛豬找房
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueQrious from 'vue-qrious'
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            size: 100,
            hostUrlTenant: window.location.href + '?device=1&type=tenant',
            hostUrlLandlord: window.location.href + '?device=1&type=landlord',
        }
    },
    computed: {
    },
    components: {
        VueQrious
    }
}
</script>

<style lang="scss" scoped>
    .download-app{
        position: absolute;
        padding: 24px;
        border-radius: 4px;
        box-shadow: 0 2px 10px 0 rgba(67, 67, 67, 0.46);
        background-color: #ffffff;
        z-index: 2;
        left: -98px;
        top: 51px;
        &.only-landlord{
            left: -40px;
        }
        .qrcode-wrap{
            display: flex;
            align-items: center;
            font-size: 14px;
            .qrcode{
                text-align: center;
                &:first-child{
                    margin-right: 20px;
                }
                &.mr-0{
                    margin-right: 0px;
                }
                .title{
                    color: #474342;
                    margin-bottom: 10px;
                }
                img{
                    border-radius: 4px;
                }
                .name{
                    margin-top: 10px;
                    font-weight: 400;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/widges/tools/downloadApp.vue